import { getNumericOnlyPhoneNumber } from './validatePhoneNumber';

export function getPhoneNumberAreaCode(input: string | undefined): string | undefined {
	// Remove all non-numeric characters
	const normalized = getNumericOnlyPhoneNumber(input);
	if (!normalized) {
		return undefined;
	}

	return normalized.slice(0, 3);
}

export function getPhoneNumberPrefix(input: string | undefined): string | undefined {
	// Remove all non-numeric characters
	const normalized = getNumericOnlyPhoneNumber(input);
	if (!normalized) {
		return undefined;
	}
	return normalized.slice(3, 6);
}

export function getPhoneNumberLineNumber(input: string | undefined): string | undefined {
	// Remove all non-numeric characters
	const normalized = getNumericOnlyPhoneNumber(input);
	if (!normalized) {
		return undefined;
	}
	return normalized.slice(6, 10);
}

export function formatPhoneNumber(input: string | undefined): string {
	// Remove all non-numeric characters
	const normalized = getNumericOnlyPhoneNumber(input);
	if (!normalized) {
		return '';
	}

	let areaCode = getPhoneNumberAreaCode(normalized);
	areaCode = areaCode ? `(${areaCode}` : '';

	let prefix = getPhoneNumberPrefix(normalized);
	prefix = prefix ? `) ${prefix}` : '';

	let lineNumber = getPhoneNumberLineNumber(normalized);
	lineNumber = lineNumber ? `-${lineNumber}` : '';

	return `${areaCode}${prefix}${lineNumber}`;
}
